import { GalleryEntity, RawGallery } from './Types';
import { MediaEntity } from '../Media/Types';
import { MediaModel } from '../Media/MediaModel';
import { BaseModel } from '../BaseModel/BaseModel';

export class GalleryModel extends BaseModel<RawGallery, GalleryEntity> implements GalleryEntity {
    createdAt: string = new Date().toISOString();
    deletedAt: string | null = null;
    galleryableId: number = 0;
    galleryableType: string = '';
    id: number = 0;
    updatedAt: string = new Date().toISOString();
    medias: MediaEntity[] = [];

    constructor(data?: RawGallery) {
        super();
        if (data) {
            this.initialize(data);
        }
    }

    initialize(data: RawGallery) {
        this.id = data.id;
        this.createdAt = data.created_at;
        this.deletedAt = data.deleted_at;
        this.galleryableId = data.galleryable_id;
        this.galleryableType = data.galleryable_type;
        this.id = data.id;
        this.updatedAt = data.updated_at;

        this.medias = data.medias.map(media => new MediaModel(media));
    }

    parse(): RawGallery {
        return {
            created_at: this.createdAt,
            updated_at: this.updatedAt,
            deleted_at: this.deletedAt,
            galleryable_id: this.galleryableId,
            id: this.id,
            galleryable_type: this.galleryableType,
            medias: this.medias.map(media => media.parse()),
        }
    }
}